import { render, staticRenderFns } from "./VitalsPopUp.vue?vue&type=template&id=684f428d&scoped=true&"
import script from "./VitalsPopUp.vue?vue&type=script&lang=js&"
export * from "./VitalsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./VitalsPopUp.vue?vue&type=style&index=0&id=684f428d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684f428d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1209661745/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('684f428d')) {
      api.createRecord('684f428d', component.options)
    } else {
      api.reload('684f428d', component.options)
    }
    module.hot.accept("./VitalsPopUp.vue?vue&type=template&id=684f428d&scoped=true&", function () {
      api.rerender('684f428d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Vitals/VitalsPopUp.vue"
export default component.exports